import axios from "axios";

export default {
  state: {
    token: {},
    sso: {},
  },
  getters: {
    getToken(state) {
      return state.token;
    },
    getSSO(state) {
      return state.sso;
    },
  },
  mutations: {
    loginSuccess(state, payload) {
      state.token = payload;
    },
    logout(state) {
      state.token = {};
    },
    ssoSession(state, payload) {
      state.sso = payload;
    },
  },
  actions: {
    setLogin(store, { tlc, password }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: process.env.VUE_APP_BACKEND + "api/login",
          data: {
            tlc: tlc,
            password: password,
          },
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then(({ data, status }) => {
            if (status === 200) {
              const storage = {
                key: data.key,
                token: data.token,
                uid_sso: null,
                ruid_sso: null,
              };
              localStorage.setItem("token", JSON.stringify(storage));
              store.commit("loginSuccess", data);
              resolve(data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setLogout(store) {
      localStorage.removeItem("token");
    },
    async getLoginSSO(store, { tlc, password }) {
      return await new Promise((resolve, reject) => {
        const params = new URLSearchParams();
        params.append('client_id', process.env.VUE_APP_SSO_CLIENT_ID);
        params.append('client_secret', process.env.VUE_APP_SSO_CLIENT_SECRET);
        params.append('grant_type', "password");
        params.append('username', tlc);
        params.append('password', password);

        axios({
          method: "post",
          url: process.env.VUE_APP_SSO + "protocol/openid-connect/token",
          data: params,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
          .then(({ data, status }) => {
            let temp = JSON.parse(localStorage.getItem("token"));
            const storage = {
              key: temp.key,
              token: temp.token,
              uid_sso: data.access_token,
              ruid_sso: data.refresh_token,
            };
            localStorage.setItem("token", JSON.stringify(storage));
            store.commit("ssoSession", data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async getSessionSSOIsActive(store, { tlc, token }) {
      return await new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SSO + "protocol/openid-connect/userinfo",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Authorization": "Bearer "+ token,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async setPasswordSSO(store, { id, token, value }) {
      return await new Promise((resolve, reject) => {
        axios({
          method: "put",
          url: process.env.VUE_APP_SSO.replace('realms','admin/realms') + "users/" + id + "/reset-password",
          data: {
            "type":"password",
            "temporary":false,
            "value": value
          },
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer "+ token
          },
        })
        .then(({ data, status }) => {
          resolve(true);
        })
        .catch((error) => {
          reject(error);
        });
      });
    },
    async setLogOutSSO(store, { token }) {
      return await new Promise((resolve, reject) => {
        const params = new URLSearchParams();
        params.append('client_id', process.env.VUE_APP_SSO_CLIENT_ID);
        params.append('client_secret', process.env.VUE_APP_SSO_CLIENT_SECRET);
        params.append('refresh_token', token);

        axios({
          method: "post",
          url: process.env.VUE_APP_SSO + "protocol/openid-connect/logout",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          data:params
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async reGenerateSecureSSO(store, { tlc, psw, tokenPandapakita }){
      return await new Promise((resolve, reject) => {
        store.dispatch("getLoginSSO", {
          tlc: tlc,
          password: process.env.VUE_APP_SSO_CLIENT_SECRET,
        }).then(async (response)=>{
          await store.dispatch("getSessionSSOIsActive", {
            tlc: tlc,
            token: response.access_token,
          }).then(async (res)=>{
            await store.dispatch("setPasswordSSO", {
              id: res.sub, 
              token: response.access_token, 
              value: psw
            }).then(async ()=>{
              // resolve(true)
              await store.dispatch("changePass", {
                old_pass: psw,
                new_pass: psw,
                confirm_pass: psw,
                sso_pass: psw,
                token: tokenPandapakita,
              }).then(()=>{
                resolve(true)
              }).catch((err)=>{
                reject(err)
              })
            })
            .catch((err)=>{
              reject(err)
            })
          }).catch((err)=>{
            reject(err)
          })
        }).catch((err)=>{
          reject(err)
        })
      })
    },
  },
};
